<template>
  <div class="login">
    <CsrfToken @loaded="csrf_token" v-model="getCSFRToken" />
    <v-row>
      <img class="logotipo" src="../../images/logotipo.png" alt="Logo" />
    </v-row>
    <p v-show="federado_message" class="login-error-cas">
      {{ federado_message }}
    </p>
    <p-button
      style="margin-bottom: 20px"
      v-show="exibirLogin.cas"
      label="Logar com a minha conta do Sicredi"
      icon="fa-arrow-right-to-bracket"
      :colorful="true"
      :onClick="login_sicredi"
    />
    <v-expansion-panels v-model="panel" v-show="exibirLogin.local">
      <PExpansionPanel header="Autenticação Local" v-model="panel" expand>
        <p v-show="message" class="login-error">{{ message }}</p>
        <PForm :outline="false" class="login-form" @keyup.native.enter="login">
          <slot />
          <PTextField
            prepend-icon="fa-user"
            label="Usuário"
            maxlength="40"
            name="usuario"
            type="text"
            autofocus
            v-model="usuario"
          />
          <PTextField
            prepend-icon="fa-lock"
            name="password"
            type="password"
            maxlength="18"
            id="password"
            label="Senha"
            v-model="senha"
          />
          <p-button label="Entrar" :colorful="true" :onClick="login" />
        </PForm>
      </PExpansionPanel>
    </v-expansion-panels>
    <p class="version">v {{ version }}</p>
    <v-overlay :value="loading" style="border-radius: 0 !important">
      <PProgressCircular indeterminate size="64" width="15" />
    </v-overlay>
  </div>
</template>

<script>
import CsrfToken from "../CSRFToken/CSRFToken.vue";

import loginService from "../../api/login";
import CSRF from "../../api/csrfMixin";
import { store } from "../../api/store";

function UserException(message) {
  this.message = message;
  this.name = "UserException";
}

export default {
  name: "p-login",

  mixins: [CSRF()],

  components: {
    PForm: () => import("../PForm/PForm.vue"),
    CsrfToken,
    PTextField: () => import("../PForm/PTextField/PTextField.vue"),
    PExpansionPanel: () => import("../PExpansionPanel/PExpansionPanel.vue"),
    PProgressCircular: () =>
      import("../PProgressCircular/PProgressCircular.vue"),
    PButton: () => import("../PButton/PButton.vue"),
  },

  props: ["loginRedirect", "loginCallback"],

  data: () => ({
    loading: false,
    message: null,
    federado_message: null,
    usuario: "",
    senha: "",
    panel: null,
    getCSFRToken: false,
    version: process.env.VUE_APP_VERSION,
    exibirLogin: {
      cas: false,
      local: false,
    },
  }),

  mounted() {
    this.setExibirLogin();

    if (this.$route && this.$route.query.message)
      this.federado_message = this.$route.query.message;

    if (!this.exibirLogin.cas) this.panel = 0;
  },

  methods: {
    setExibirLogin: function () {
      if (
        !process.env.VUE_APP_EXIBIR_LOGIN_LOCAL &&
        !process.env.VUE_APP_EXIBIR_LOGIN_CAS
      ) {
        if (localStorage.getItem("casLoginContext")) {
          localStorage.removeItem("casLoginContext");

          this.$router.push({ path: process.env.VUE_APP_LOGIN_CAS_PATH });

          this.exibirLogin = {
            cas: true,
            local: false,
          };
        } else {
          localStorage.setItem(
            "loginContext",
            this.$route.path === process.env.VUE_APP_LOGIN_CAS_PATH
              ? "cas"
              : "local"
          );

          this.exibirLogin = {
            cas: this.$route.path === process.env.VUE_APP_LOGIN_CAS_PATH,
            local: this.$route.path === process.env.VUE_APP_LOGIN_LOCAL_PATH,
          };
        }
      } else {
        this.exibirLogin = {
          cas: process.env.VUE_APP_EXIBIR_LOGIN_CAS === "true",
          local: process.env.VUE_APP_EXIBIR_LOGIN_LOCAL === "true",
        };
      }
    },

    login: function () {
      this.loading = !this.loading;
      this.message = null;
      loginService.API.Actions.login(this.usuario, this.senha, this._token)
        .then((resp) => {
          if (resp.status == 200) {
            store.dispatch("login", resp.data).then(() => {
              if (this.loginCallback) this.loginCallback(resp.data);

              this.$router.push({ name: this.loginRedirect });
              this.loading = false;
            });
          } else {
            throw UserException(resp.data.error ? resp.data.error : "Usuário ou senha incorretos!");
          }
        })
        .catch((err) => {
          this.loading = false;
          this.message = err.response.data.error ? err.response.data.error : "Usuário ou senha incorretos!";
          this.getCSFRToken = !this.getCSFRToken;
        });
    },

    login_sicredi: function () {
      let pkce = this.generate_pkce();

      localStorage.setItem("code_verifier", pkce.get("code_verifier"));

      window.location.href =
        process.env.VUE_APP_BASE_API +
        "/" +
        process.env.VUE_APP_LOGIN_BACKEND_CAS +
        "?code_challenge=" +
        pkce.get("code_challenge");
    },

    generate_pkce: function () {
      let code_verifier = "";

      let chars =
        "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";

      for (let i = 0; i < 30; i++) {
        code_verifier += chars.charAt(Math.floor(Math.random() * chars.length));
      }

      let sha256 = require("js-sha256").sha256;
      let code_challenge = sha256(code_verifier);
      let pkce = new Map();

      pkce.set("code_verifier", code_verifier);
      pkce.set("code_challenge", code_challenge);

      return pkce;
    },
  },
};
</script>

<style scoped>
@import "./styles.css";
</style>
